import PropTypes from 'prop-types';
import styled from 'styled-components';

import { breakpoints, zIndexes } from '../../../constants';
import { Col, Container, Row } from '../../grid';
import { DecalWrapper } from '../../decal-wrapper';

const Wrapper = ({ decals, children, onArrowClick, overflow, enableBackgroundPattern, isFullWidthMobile, ...rest }) => {
  return (
    <DecalWrapper {...decals} overflow="hidden">
      <Container
        overflow={overflow}
        position="relative"
        flexDirection="column"
        alignItems="center"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'ArrowLeft') {
            onArrowClick('left');
          } else if (e.key === 'ArrowRight') {
            onArrowClick('right');
          }
        }}
        {...rest}
      >
        <Row>
          <Col width={{ _: 1, lg: 10 / 12 }} offset={[null, null, null, 1 / 12]} position="relative">
            {enableBackgroundPattern
              ? { ...children, props: { ...children.props, zIndex: zIndexes[1], px: '2rem' } }
              : children}

            {enableBackgroundPattern && (
              <StyledSvg viewBox="0 0 1096 380" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 379.138L1096 319V6.10352e-05L0 61.0001V379.138Z" fill="#14E0C2" />
                <mask
                  id="mask0_4819_47839"
                  style={{ maskType: 'alpha' }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="1096"
                  height="380"
                >
                  <path d="M0 379.138L1096 319V6.10352e-05L0 61.0001V379.138Z" fill="#FE4047" />
                </mask>
                <g mask="url(#mask0_4819_47839)">
                  <path
                    d="M1363.3 -131.92L1363.3 -132.435C1363.26 -132.604 1363.26 -132.782 1363.31 -132.95C1360.44 -161.836 1351.9 -189.797 1338.2 -215.084C1321.5 -241.091 1299.42 -262.872 1273.59 -278.827C1267.41 -283.829 1261.91 -288.412 1256.81 -293.094C1252.45 -296.491 1248.92 -300.914 1246.5 -306.002C1244.09 -311.091 1242.86 -316.701 1242.92 -322.377C1243.02 -324.675 1243.37 -326.953 1243.97 -329.167C1243.97 -329.682 1243.97 -330.095 1243.98 -330.507L1243.98 -331.228C1248.13 -350.687 1258.79 -367.974 1274.04 -379.994C1274.73 -380.73 1275.22 -381.632 1275.49 -382.619C1275.76 -383.606 1275.78 -384.646 1275.57 -385.647C1275.38 -386.364 1275.03 -387.026 1274.55 -387.583C1274.08 -388.141 1273.49 -388.579 1272.83 -388.865L1252.18 -401.932C1251.06 -402.542 1249.79 -402.804 1248.53 -402.686L1248.04 -402.691C1231.52 -399.138 1216.92 -389.182 1207.18 -374.834C1197.55 -360.725 1190.2 -345.059 1185.45 -328.464C1183.09 -323.853 1179.83 -319.816 1175.87 -316.619C1171.9 -313.423 1167.33 -311.14 1162.46 -309.923C1158.1 -308.52 1153.25 -307.019 1147.4 -305.424C1144.73 -305.448 1142.06 -304.648 1139.58 -304.258C1133.05 -303.597 1110.66 -297.207 1108.09 -296.509L1106.61 -296.523L1105.62 -296.532C1098.58 -294.153 1091.72 -291.254 1085.09 -287.858C1079.53 -285.333 1015.61 -253.359 1004.38 -151.157C1002.04 -128.344 1002.14 -105.328 1004.7 -82.5391C1004.67 -79.0364 1004.64 -75.3278 1004.61 -71.5161L1004.6 -70.589C1019.54 34.6333 1016.19 247.145 909.447 377.324C909.447 377.324 887.862 405.563 909.782 432.034C913.489 436.193 917.963 439.528 922.938 441.84C927.912 444.151 933.283 445.391 938.728 445.485C957.822 445.845 976.815 442.525 994.752 435.693C1032.03 424.244 1067.75 407.845 1101.01 386.899C1118.48 376.544 1135.26 364.959 1151.21 352.224L1158.58 346.213C1165.84 340.406 1172.71 334.802 1177.29 330.414C1194.7 315.455 1210.66 298.761 1224.95 280.572L1225.45 280.576C1228.24 276.79 1231.74 272.494 1235.43 268.407C1240.52 262.066 1245.42 256.135 1247.62 252.549C1265.95 228.027 1281.9 201.667 1295.22 173.859L1316.07 127.172C1331.17 90.9661 1343.35 53.5151 1352.49 15.2055C1363.98 -32.8574 1367.63 -82.5925 1363.3 -131.92Z"
                    fill="#11C6AC"
                  />
                  <path
                    d="M-296.928 -30.7128L-296.928 -31.3024C-296.874 -31.4949 -296.874 -31.6994 -296.928 -31.8919C-293.385 -64.9222 -283.364 -96.8335 -267.493 -125.632C-248.19 -155.223 -222.795 -179.92 -193.173 -197.912C-186.068 -203.572 -179.752 -208.76 -173.888 -214.066C-168.877 -217.908 -164.805 -222.933 -162.003 -228.732C-159.2 -234.53 -157.747 -240.939 -157.761 -247.435C-157.852 -250.066 -158.23 -252.677 -158.888 -255.217C-158.888 -255.807 -158.888 -256.279 -158.888 -256.75L-158.888 -257.576C-163.436 -279.89 -175.429 -299.786 -192.722 -313.702C-193.496 -314.551 -194.056 -315.589 -194.351 -316.721C-194.646 -317.853 -194.668 -319.044 -194.413 -320.187C-194.184 -321.006 -193.781 -321.76 -193.235 -322.393C-192.688 -323.026 -192.011 -323.521 -191.255 -323.842L-167.572 -338.581C-166.285 -339.268 -164.837 -339.554 -163.4 -339.407L-162.836 -339.407C-144.027 -335.169 -127.459 -323.621 -116.484 -307.099C-105.622 -290.851 -97.3922 -272.845 -92.1242 -253.803C-89.4828 -248.501 -85.7945 -243.846 -81.3034 -240.147C-76.8122 -236.447 -71.6208 -233.787 -66.0727 -232.343C-61.1105 -230.692 -55.5844 -228.923 -48.9305 -227.036C-45.8855 -227.036 -42.8406 -226.093 -40.0211 -225.622C-32.5778 -224.796 -7.09018 -217.25 -4.15796 -216.424L-2.46631 -216.424L-1.33854 -216.424C6.66369 -213.629 14.4651 -210.24 22.0063 -206.284C28.3219 -203.336 100.95 -166.076 112.792 -48.9892C115.254 -22.855 114.914 3.48515 111.777 29.5403C111.777 33.5493 111.777 37.7941 111.777 42.1569L111.777 43.2181C93.7327 163.488 95.5372 406.741 216.096 556.843C216.096 556.843 240.456 589.387 215.194 619.455C210.925 624.176 205.787 627.946 200.089 630.54C194.392 633.133 188.251 634.497 182.037 634.547C160.247 634.76 138.607 630.762 118.205 622.756C75.775 609.265 35.1805 590.124 -2.57903 565.805C-22.4155 553.771 -41.4438 540.337 -59.5315 525.597L-67.8771 518.64C-76.1098 511.919 -83.8914 505.434 -89.0792 500.363C-108.795 483.061 -126.85 463.789 -142.987 442.822L-143.551 442.822C-146.708 438.459 -150.656 433.507 -154.828 428.791C-160.58 421.48 -166.106 414.641 -168.587 410.514C-189.268 382.258 -207.212 351.924 -222.156 319.958L-245.501 266.308C-262.38 224.713 -275.922 181.724 -285.988 137.784C-298.642 82.6563 -302.34 25.6967 -296.928 -30.7128Z"
                    fill="#11C6AC"
                  />
                </g>
              </StyledSvg>
            )}
          </Col>
        </Row>
      </Container>
    </DecalWrapper>
  );
};

const StyledSvg = styled.svg`
  position: absolute;
  bottom: 0;
  z-index: 0;
  height: 60%;

  @media (min-width: ${breakpoints.lg}) {
    height: auto;
  }
`;

Wrapper.propTypes = {
  decals: PropTypes.shape({
    leftDecal: PropTypes.node,
    rightDecal: PropTypes.node,
  }),
  children: PropTypes.node,
  onArrowClick: PropTypes.func,
  overflow: PropTypes.string,
  enableBackgroundPattern: PropTypes.bool,
  isFullWidthMobile: PropTypes.bool,
};

Wrapper.defaultProps = {
  decals: {
    leftDecal: null,
    rightDecal: null,
  },
  children: null,
  onArrowClick: () => {},
  overflow: 'hidden',
  enableBackgroundPattern: false,
  isFullWidthMobile: false,
};

export { Wrapper };
